export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const API_KEY = `8c9432a1-df8d-4118-a71a-9895ee3dcde4`;
export const MODAL_CLOSE_SEC = 1.5;
